import { Box, BoxProps } from '@mui/material';
import logoSrc from '../assets/imc-logo.png';

interface LogoProps extends Omit<BoxProps<'img'>, 'component' | 'src'> {
  height?: number;
}

/** IMC wordmark. The source PNG already includes brand colors and tagline. */
export const Logo = ({ height = 40, sx, ...rest }: LogoProps) => (
  <Box
    component="img"
    src={logoSrc}
    alt="IMC — Nurturing Caring Minds for the World"
    sx={{ height, width: 'auto', display: 'block', ...sx }}
    {...rest}
  />
);
